/**
 * 260812 인앱 브라우저 감지 + 외부 브라우저 탈출.
 *
 * 왜 필요한가 — 카카오톡으로 받은 QR 링크를 그 자리에서 열면 **카톡 인앱 브라우저**가 뜨는데,
 * 여기서는 `intent://`(안드로이드 앱 열기)가 대부분 차단된다. 사용자 눈에는 "정품등록을 눌렀는데
 * 아무 일도 안 나거나 웹으로 빠진다"로 보인다(260812 유저 신고). 링크 공유가 카톡으로 이뤄지는 서비스라
 * 이 경로가 예외가 아니라 주 경로에 가깝다.
 *
 * 카톡만 공식 탈출구가 있다: `kakaotalk://web/openExternal?url=…` → 기기 기본 브라우저로 다시 연다.
 * 나머지(인스타·페북·네이버앱·라인 등)는 보편적 수단이 없어 안내만 한다.
 *
 * ⚠️앱(간판ON) 웹뷰는 여기 해당하지 않는다 — UA에 `_jump`가 붙어 isApp()으로 먼저 걸러진다.
 */

/** 카카오톡 인앱 브라우저 */
const KAKAO = /KAKAOTALK/i;

/** 탈출구가 없는 나머지 인앱 브라우저들 — 안내만 가능 */
const OTHER_INAPP = /NAVER\(inapp|Instagram|FBAN|FBAV|FB_IAB|Line\/|DaumApps|everytimeApp|kakaostory/i;

export const isKakaoInApp = () => KAKAO.test(navigator.userAgent);

export const isInAppBrowser = () => {
  const ua = navigator.userAgent;
  return KAKAO.test(ua) || OTHER_INAPP.test(ua);
};

/**
 * 인앱 브라우저면 탈출을 시도하고 true를 돌려준다(= 호출부는 하던 일을 멈춰야 한다).
 * 인앱이 아니면 false — 호출부가 원래 하려던 딥링크를 그대로 쏘면 된다.
 *
 * @param {string} url 외부 브라우저에서 열 주소(기본값 현재 주소)
 * @param {(msg: string) => void} notify 탈출구가 없을 때 사용자에게 보여줄 안내 함수
 */
export const escapeInAppBrowser = (url = window.location.href, notify = null) => {
  if (isKakaoInApp()) {
    // 카톡 전용 스킴 — 기본 브라우저로 같은 주소를 다시 연다. 거기서는 intent://가 정상 동작한다.
    window.location.href = `kakaotalk://web/openExternal?url=${encodeURIComponent(url)}`;
    return true;
  }
  if (OTHER_INAPP.test(navigator.userAgent)) {
    if (notify) {
      notify('앱으로 열려면 기본 브라우저가 필요해요.\n오른쪽 위 메뉴에서 "다른 브라우저로 열기"를 눌러주세요.');
    }
    return true;
  }
  return false;
};
